import { Link, useLocation } from 'react-router-dom';
import { Calculator, LogOut, Route } from 'lucide-react';
import { Button } from '@/components/ui/button';

const navItems = [
  { to: '/staff', label: 'My Jobs', icon: Route, testId: 'field-tech-nav-jobs-link' },
  { to: '/mobile-estimator', label: 'Estimator', icon: Calculator, testId: 'field-tech-nav-estimator-link' },
];

export function FieldTechNav({ onLogout }) {
  const location = useLocation();

  return (
    <nav className="mb-4 grid grid-cols-[1fr_1fr_auto] gap-2 rounded-md border border-zinc-200 bg-white p-1 shadow-sm" data-testid="field-tech-nav">
      {navItems.map((item) => {
        const Icon = item.icon;
        const active = location.pathname === item.to;
        return (
          <Link
            key={item.to}
            to={item.to}
            className={`inline-flex h-10 items-center justify-center gap-1.5 rounded px-3 text-xs font-bold transition-colors ${active ? 'bg-zinc-950 text-white' : 'text-zinc-600 hover:bg-zinc-100 hover:text-zinc-950'}`}
            data-testid={item.testId}
            aria-current={active ? 'page' : undefined}
          >
            <Icon className="h-3.5 w-3.5" />
            {item.label}
          </Link>
        );
      })}
      <Button type="button" variant="ghost" size="sm" onClick={onLogout} className="h-10 px-3" data-testid="field-tech-nav-logout-button" aria-label="Logout">
        <LogOut className="h-4 w-4" />
      </Button>
    </nav>
  );
}